export enum EventVisibilityEnum {
    PRIVATE = 0,
    FOR_FRIENDS = 1,
    PUBLIC = 2
}
